import React, { useEffect, useState } from "react";
import EnvironmentPermissionList, {
  EnvironmentPermission,
} from "../components/EnvironmentPermissionList";
import { Environment } from "../_generated";
import axios from "axios";
import { BackendURL } from "../globals";
import { authToken } from "../components/Authentication";
import analytics from "../analytics";

export default function EnvironmentAccessPage({
  projectName,
  environment,
}: {
  projectName: string;
  environment: Environment;
}) {
  const [permissions, setPermissions] = useState([] as EnvironmentPermission[]);
  const apiRoot = `${BackendURL}/api`;
  const url = `${apiRoot}/projects/${projectName}/environments/${environment.pk}/permissions/`;

  axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

  const handlePermissionsUpdate = async (
    newPermissions: EnvironmentPermission[]
  ) => {
    //TODO call permissions update endpoint
    setPermissions(newPermissions);
    axios.put(url, {
      permissions: newPermissions,
    });
  };

  useEffect(() => {
    analytics.page("EnvironmentAccess");
  }, []);

  useEffect(() => {
    axios.get(url).then((response) => {
      setPermissions(response.data.results);
    });
  }, [apiRoot, environment, projectName, url]);

  return (
    <EnvironmentPermissionList
      permissions={permissions}
      onPermissionsUpdate={handlePermissionsUpdate}
    />
  );
}
